module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/animations/test/test.component.scss
// module id = ./src/app/animations/test/test.component.scss
// module chunks = main